import { Card } from '@salonomy/ui';
import { useAuth } from '../../lib/auth.js';
import { IntegrationsHealthPanel } from './IntegrationsHealthPanel.js';
import { TokensPanel } from './TokensPanel.js';
import { WebhooksPanel } from './WebhooksPanel.js';

/**
 * Developer & integrations section for Settings (WS6 brief item 6) — replaces the "Developer &
 * integrations" ComingSoon in SettingsPage. Composes:
 *   - TokensPanel              — personal access tokens (create/revoke, scope picker)
 *   - WebhooksPanel            — webhook endpoints CRUD, event picker, delivery log, redeliver, test
 *   - IntegrationsHealthPanel  — Stripe Connect onboarding status + re-onboarding link, comms health
 *
 * OWNER/MANAGER ONLY. Every underlying API route is requireManager on the server; the UI mirrors
 * that here so a non-manager who reaches this surface sees a legible explanation, never a wall of
 * 403s. SettingsPage already renders the whole manager view behind `isManager`, so in practice this
 * panel only mounts for managers — but the gate is defensive and self-contained so the export is
 * safe to mount anywhere.
 */
export function DeveloperPanel() {
  const { isManager } = useAuth();

  if (!isManager) {
    return (
      <Card>
        <div className="section-title">Developer &amp; integrations</div>
        <div className="muted" style={{ fontSize: 13, marginTop: 6 }}>
          Only an owner or manager can manage API tokens, webhooks and payment/messaging
          integrations.
        </div>
      </Card>
    );
  }

  return (
    <>
      <TokensPanel />
      <WebhooksPanel />
      <IntegrationsHealthPanel />
    </>
  );
}
